import { render, staticRenderFns } from "./BlogView.vue?vue&type=template&id=63f4ba3d&scoped=true&"
import script from "./BlogView.vue?vue&type=script&lang=js&"
export * from "./BlogView.vue?vue&type=script&lang=js&"
import style0 from "./BlogView.vue?vue&type=style&index=0&id=63f4ba3d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f4ba3d",
  null
  
)

export default component.exports